import { render, staticRenderFns } from "./complainers.vue?vue&type=template&id=72525b2e&scoped=true"
import script from "./complainers.vue?vue&type=script&lang=js"
export * from "./complainers.vue?vue&type=script&lang=js"
import style0 from "./complainers.vue?vue&type=style&index=0&id=72525b2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72525b2e",
  null
  
)

export default component.exports